<template>
  <Modal
    v-model="_value"
    width="500"
    title="修改定位设备服务到费期"
    @on-visible-change="visibleChange"
    @on-ok="onOk"
    ok-text="修改">
    <Form ref="loginForm" :model="positioningDeviceInfo" style="display: inline;">
      <FormItem prop="serviceDatetime">
        <label style="display: inline-block; width: 60px;">服务到费期</label>
        <DatePicker style="display: inline-block; width: 200px;" type="date"
                    v-model="positioningDeviceInfo.serviceDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'modifypositioningdeviceservicedatetimemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        positioningDeviceInfo: {
          id: null,
          serviceDatetime: null
        }
      }
    },
    methods: {
      ...mapActions([
        'PositioningDeviceInfoServ_GetDetail',
        'PositioningDeviceInfoServ_ModifyServiceDatetime'
      ]),
      onOk() {
          this.$Modal.confirm({
            title: '提示',
            content: '<p>确认修改服务到费期</p>',
            onOk: () => {
              if (this.positioningDeviceInfo.serviceDatetime) {
                this.positioningDeviceInfo.serviceDatetime = new Date(this.positioningDeviceInfo.serviceDatetime).getTime();
              }
              store.dispatch('PositioningDeviceInfoServ_ModifyServiceDatetime', {
                params: this.positioningDeviceInfo
              }).then(() => {
                this.$Message.success('修改成功')
                this.$emit('on-success')
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail')
              })
            },
            onCancel: () => {

            }
          })
      },
      visibleChange(val) {
        if (val) {
          this.positioningDeviceInfo.id = null
          this.positioningDeviceInfo.serviceDatetime = null
          store.dispatch('PositioningDeviceInfoServ_GetDetail', {
            params: {id: this._initValue}
          }).then(() => {
            this.positioningDeviceInfo = store.getters.get_PositioningDeviceInfo_GetDetailResult;
            if (this.positioningDeviceInfo.serviceDatetime) {
              this.positioningDeviceInfo.serviceDatetime = new Date(this.positioningDeviceInfo.serviceDatetime)
            }
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
